import TKModuleFactory from "@tk/utilities/tk.module.factory";
import TKManager from "@tk/basiscs/tk.manager";
import TKButtonDropdown from "@tk/controls/tk.button.dropdown";
import TKViewport from "@tk/basiscs/tk.viewport";
import TKBasketButton from "@tk/components/tk.basket.button";
import TKCarousel from "@tk/components/tk.carousel";
import TKContextMenu from "@tk/components/tk.context.menu";
import TKFlag from "@tk/components/tk.flag";
import TKMinibasket from "@tk/components/tk.minibasket";
import TKProductTile from "@tk/components/tk.product.tile";
import TKProductVariants from "@tk/components/tk.product.variants";
import TKTooltip from "@tk/components/tk.tooltip";
import TKDialog from "@tk/components/tk.dialog";
import TKStock from "@tk/components/tk.stock";
import TKStaticContent from "@tk/controls/tk.static.content";
import TKTabsTab from "@tk/controls/tk.tabs.tab";
import TKFavoriteButton from "@tk/components/tk.favorite.button";
import TKFavoriteInfo from "@tk/components/tk.favorite.info";
import TKFormValidator from "@tk/controls/tk.form.validator";
import TKTabsAccordion from "@tk/controls/tk.tabs.accordion";
import TKSelection from "@tk/controls/tk.selection";
import TKArtSpecTable from "@tk/components/tk.art.spec.table";
import TKSelectRedirect from "@tk/controls/tk.select.redirect";
import TKPopup from "@tk/components/tk.popup";
import TKArticleListSort from "@tk/components/tk.article.list.sort";
import TKArticleListLayoutSwitch from "@tk/components/tk.article.list.layout.switch";
import TKBreadcrumb from "@tk/components/tk.breadcrumb";
import TKTable from "@tk/components/tk.table";
import GTAFormElement from "@/controls/gta.form.element";
import GTAHeader from "@/components/gta.header";
import OpenOffers from "@/components/gta.open.offers";
import GTABarcodeScanner from "@/components/gta.barcode.scanner";
import GTADialog from "@/components/gta.dialog";
import GTADimInfoTableHelper from "@/components/gta.diminfo.table.helper";
import GTASelection from "@/controls/gta.selection";
import GTATable from "@/components/gta.table";
import GTASearch from "@/controls/gta.search";
import GTAAssetGallery from "@/components/gta.asset.gallery";
import GTANavigationSidebar from "@/components/gta.navigation.sidebar";
import GTAShowMore from "@/components/gta.show.more";
import GTAPrice from "@/components/gta.price";
import GTABackLink from "@/components/gta.backlink";
import GTAArticleList from "@/components/gta.article.list";

import "@css/modules/article.css";
import "@splidejs/splide/dist/css/splide.min.css";
import "tippy.js/dist/tippy.css";

export default class Article extends TKModuleFactory {
    constructor() {
        super([
            { name: "tk-manager", constructor: TKManager },
            { name: "tk-viewport", constructor: TKViewport },
            { name: "tk-button-dropdown", constructor: TKButtonDropdown },
            { name: "tk-header", constructor: GTAHeader },
            { name: "open-offers", constructor: OpenOffers },
            { name: "tk-nav-sidebar", constructor: GTANavigationSidebar },
            { name: "gta-search", constructor: GTASearch },
            { name: "tk-basket-button", constructor: TKBasketButton },
            { name: "tk-carousel", constructor: TKCarousel },
            { name: "tk-context-menu", constructor: TKContextMenu },
            { name: "tk-flag", constructor: TKFlag },
            { name: "tk-minibasket", constructor: TKMinibasket },
            { name: "tk-product-tile", constructor: TKProductTile },
            { name: "tk-product-variants", constructor: TKProductVariants },
            { name: "tk-tooltip", constructor: TKTooltip },
            { name: "tk-dialog", constructor: TKDialog },
            { name: "gta-dialog", constructor: GTADialog },
            { name: "tk-article-list", constructor: GTAArticleList },
            { name: "tk-price", constructor: GTAPrice },
            { name: "tk-stock", constructor: TKStock },
            { name: "tk-static-content", constructor: TKStaticContent },
            { name: "tk-tabs-tab", constructor: TKTabsTab },
            { name: "tk-tabs-accordion", constructor: TKTabsAccordion },
            { name: "tk-favorite-button", constructor: TKFavoriteButton },
            { name: "tk-favorite-info", constructor: TKFavoriteInfo },
            { name: "tk-form-element", constructor: GTAFormElement },
            { name: "tk-form-validator", constructor: TKFormValidator },
            { name: "tk-asset-gallery", constructor: GTAAssetGallery },
            { name: "tk-selection", constructor: TKSelection },
            { name: "tk-art-spec-table", constructor: TKArtSpecTable },
            { name: "tk-show-more", constructor: GTAShowMore },
            { name: "tk-select-redirect", constructor: TKSelectRedirect },
            { name: "tk-popup", constructor: TKPopup },
            { name: "tk-article-list-sort", constructor: TKArticleListSort },
            {
                name: "tk-article-list-layout-switch",
                constructor: TKArticleListLayoutSwitch,
            },
            { name: "tk-breadcrumb", constructor: TKBreadcrumb },
            { name: "gta-table", constructor: GTATable },
            { name: "gta-barcode-scanner", constructor: GTABarcodeScanner },
            {
                name: "gta-diminfo-table-helper",
                constructor: GTADimInfoTableHelper,
            },
            { name: "gta-selection", constructor: GTASelection },
            { name: "tk-table", constructor: TKTable },
            { name: "gta-back-link", constructor: GTABackLink },
        ]);
    }
}

// eslint-disable-next-line no-new
new Article();
